import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useVendorQuotationExcelDetailContext, VendorQuotationExcelDetailContext } from "contexts/VendorQuotationExcelContext";
import VendorQuotationExcelBasicDetail from "./vendorQuotationExcelComponents/VendorQuotationExcelBasicDetail";
import { useGetVendorQuotationExcelDetailQuery } from "store/services/vendorQuotationExcelApi";

const VendorQuotationExcelDetailScreen = () => {
    const { id } = useParams();

    const breadcrumbs = [
        { title: "Vendor Quotation Excels", path: "/app/crm/vendor-quotation-excel/list" },
        { title: "Vendor Quotation Excel Detail" },
    ];

    const {
        data: priceListDetail,
        isLoading: loadingPriceList,
        error,
    } = useGetVendorQuotationExcelDetailQuery(id, {
        skip: !id,
    });


    return (
        <VendorQuotationExcelDetailContext.Provider value={{ priceListDetail, loadingPriceList }}>
            <BreadcrumbLayout
                breadcrumbs={breadcrumbs}
                isBusy={loadingPriceList}
                headerActions={<PageActions />}
            >
                <BreadcrumbLayout.Error error={error} />
                <BreadcrumbLayout.Paper>
                    <VendorQuotationExcelBasicDetail />
                    <Divider />
                </BreadcrumbLayout.Paper>
            </BreadcrumbLayout>
        </VendorQuotationExcelDetailContext.Provider>
    );
};

export default VendorQuotationExcelDetailScreen;

const PageActions = () => {
    const { priceListDetail } = useVendorQuotationExcelDetailContext();
    return (
        <div className="flex items-center gap-4">
            <Link to={`/app/crm/vendor-quotation-excel/${priceListDetail?._id}/edit`}>
                <Button startIcon={<EditOutlined />} variant="contained">
                    Edit
                </Button>
            </Link>
        </div>
    );
};